const updateCurrentArticulos = ({
  currentArticulos,
  categoriasSelected,
}: $TSMigrationFixMe) => {
  const newArticulosByCategoria = { ...currentArticulos }

  Object.keys(newArticulosByCategoria).forEach((categoriaNombre) => {
    const { articulos: currentArticulos } =
      newArticulosByCategoria[categoriaNombre]

    const articulosSelected =
      categoriasSelected[categoriaNombre]?.articulos || []

    const articulosSelectedIds = new Set(
      articulosSelected.map((art: $TSMigrationFixMe) => art.id)
    )

    const newArticulos = currentArticulos.map(
      (articulo: $TSMigrationFixMe) => ({
        ...articulo,
        isSelected: articulosSelectedIds.has(articulo.id),
      })
    )

    newArticulosByCategoria[categoriaNombre] = {
      ...newArticulosByCategoria[categoriaNombre],
      articulos: newArticulos,
    }
  })

  return newArticulosByCategoria
}

export default updateCurrentArticulos
